export default __webpack_public_path__ + "static/Card9-66a36db4d8a538d81b25e6df0aac923d.png";